import {
  createTripEventApi,
  deleteTripEventApi,
  getTripEventsApi,
  updateTripEventApi,
  handleCventUrl,
} from '../../services/api/mytrips.service';
import { selectAccessToken } from '../selectors/auth.selector';
import { selectConstructedEvent } from '../selectors/mytrips.selector';
import { selectAllTripEvents } from '../selectors/events.selector';
export const SET_TRIP_EVENTS = 'SET_TRIP_EVENTS';
export const SET_SELECTED_EVENT = 'SET_SELECTED_EVENT';
export const SET_EVENTS = 'SET_EVENTS';
export const SET_CVENT_URL = 'SET_CVENT_URL';
export const setTripEvents = (events) => {
  return async (dispatch) => {
    dispatch({
      type: SET_TRIP_EVENTS,
      payload: { events },
    });
  };
};

export const updateTripEvent = (newEvent) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const oldTripEvents = [...selectAllTripEvents(getState())];
    await updateTripEventApi(accessToken, newEvent);
    const index = oldTripEvents.findIndex((item) => item.Id === newEvent.Id);
    newEvent.StartDate = new Date(newEvent.EventDate);
    oldTripEvents[index] = newEvent;
    dispatch(setTripEvents(oldTripEvents));
  };
};
export const addTripEvent = (newEvent) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const oldTripEvents = selectAllTripEvents(getState());
    const createdEvent = await createTripEventApi(accessToken, newEvent);
    createdEvent.StartDate = new Date(createdEvent.EventDate);
    dispatch(setTripEvents([...oldTripEvents, createdEvent]));
  };
};
export const deleteTripEvents = (eventId) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const oldTripEvents = [...selectAllTripEvents(getState())];
    await deleteTripEventApi(accessToken, eventId);
    const index = oldTripEvents.findIndex((item) => item.Id === eventId);
    oldTripEvents.splice(index, 1);
    dispatch(setTripEvents(oldTripEvents));
  };
};
export const fetchTripEvents = (tripId) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const tripEvents = await getTripEventsApi(accessToken, tripId);
    const constructedEvents = selectConstructedEvent(getState());
    constructedEvents.map((event) => {
      tripEvents.push(event);
    });
    dispatch(setTripEvents(tripEvents.map((ev) => ({ ...ev, StartDate: ev.EventDate }))));
  };
};

export const fetchCventEvent = (url) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const cvent = await handleCventUrl(accessToken, url);
    dispatch({
      type: SET_CVENT_URL,
      cventUrl: cvent,
    });
  };
};

export const setSelectedEvent = (event) => async (dispatch) =>
  dispatch({
    type: SET_SELECTED_EVENT,
    payload: event,
  });

export const setEvents = (value) => {
  return async (dispatch) => {
    dispatch({
      type: SET_EVENTS,
      event: value,
    });
  };
};
